let backendHost;

const hostname = window && window.location && window.location.hostname;

if(hostname === 'cokear-e6b11.firebaseapp.com') {
    backendHost = 'https://cokear-e6b11.firebaseapp.com/api';
} else if (hostname === 'localhost') {
    backendHost = 'http://localhost:5000/api';
} else {
    backendHost = 'https://cokear-e6b11.firebaseapp.com/api';
}

export const API_ROOT = `${backendHost}`;


// WEBPACK FOOTER //
// ./src/config/config.js